import React from 'react';
import dayjs from 'dayjs';
import { formatNumberLength } from '../../helpers';

//Estilos
import './DJCE.css';
import print from '../../assets/imgs/print.png';

//Componentes
import DJCELogsContainer from '../../components/DJCELogs/DJCELogsContainer';

function DJCE({ functions, states }) {
    const { formatNumber, setWatchDJCELogs, handlePrint } = functions;

    const { user, masters, WatchDJCELogs, DJCEData, Coordinates } = states;

    const Titulares = DJCEData?.declaracion?.titulares?.split('/');
    const TitularesDoc = DJCEData?.declaracion?.titulares_Documento?.split('/');

    return (
        <div className="DJCE-container">
            <h4 className="DJCE-title">
                Declaración Jurada de Cosecha Efectiva{' '}
                {DJCEData?.declaracion?.serie}-
                {masters.LetterTypes?.find((lt) => lt.id === 4).nombre}-
                {formatNumber(DJCEData?.declaracion?.numero, 4)}
            </h4>
            <section className="DJCE-info-section">
                <label className="DJCE-label">
                    <span>Habilitada: </span>
                    <p>
                        {masters.HabilitationTypes?.find(
                            (ht) => ht.id === DJCEData?.declaracion?.habilitada
                        )?.nombre.replace('_', ' ')}
                    </p>
                </label>
                <label className="DJCE-label">
                    <span>Fecha: </span>
                    <p>
                        {dayjs(DJCEData?.declaracion?.fecha).format(
                            'DD-MM-YYYY'
                        )}
                    </p>
                </label>
                <label className="DJCE-label">
                    <span>Padrones: </span>
                    <p>{DJCEData?.declaracion?.padrones?.replace('_', ', ')}</p>
                </label>
                <label className="DJCE-label">
                    <span>Timbre: </span>
                    <p>{DJCEData?.declaracion?.timbre ? 'PAGO' : 'NO PAGO'}</p>
                </label>
                <label className="DJCE-label">
                    <span>Viñedo: </span>
                    <p>{DJCEData?.declaracion?.viniedo}</p>
                </label>
                <label className="DJCE-label">
                    <span>Teléfono: </span>
                    <p>{DJCEData?.declaracion?.telefono}</p>
                </label>
                <label className="DJCE-label">
                    <span>Titulares: </span>
                    <p>{Titulares?.join(' / ')}</p>
                </label>
                <label className="DJCE-label">
                    <span>Número Documento: </span>
                    <p>{TitularesDoc?.join(' / ')}</p>
                </label>
                <label className="DJCE-label">
                    <span>Ubicación: </span>
                    <p>
                        Lon: {formatNumberLength(Coordinates?.lon)}, Lat:{' '}
                        {formatNumberLength(Coordinates?.lat)}
                    </p>
                </label>
                <label className="DJCE-label">
                    <span>Departamento: </span>
                    <p>{DJCEData?.declaracion?.departamento}</p>
                </label>
                <label className="DJCE-label">
                    <span>Superficie: </span>
                    <p>{DJCEData?.declaracion?.total_Superficie} m²</p>
                </label>
                {/* <label className="DJCE-label">
                    <span>Responsable: </span>
                    <p>
                        {nombre} {apellido} ({usuario})
                    </p>
                </label> */}
            </section>
            <h4 className="DJCE-title">Guías Utilizadas</h4>
            <section className="DJCE-info-section">
                <table>
                    <thead>
                        <tr>
                            <th>Destino</th>
                            <th>Comprador</th>
                            <th>Nro Inscripción del Comprador</th>
                            <th>Nro Guía</th>
                            <th>Variedad</th>
                            <th>Kilos</th>
                            <th>Grado Glucosa</th>
                            <th>Precio por Kg</th>
                        </tr>
                    </thead>
                    <tbody>
                        {DJCEData?.djceGuias?.map((dg, i) => {
                            return (
                                <tr key={i}>
                                    <td>
                                        {masters?.Destinos?.find(
                                            (d) => d.id === dg.destino
                                        )?.nombre.replaceAll('_', ' ')}
                                    </td>
                                    <td>{dg.comprador}</td>
                                    <td>{dg.nro_Inscripcion}</td>
                                    <td>{dg.guiaNum}</td>
                                    <td>{dg.variedad}</td>
                                    <td>{dg.kilos} kg</td>
                                    <td>{dg.grado_Gluc}</td>
                                    <td>{dg.precio_Kg}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </section>
            <h4 className="DJCE-title">Producción de Uva</h4>
            <section className="DJCE-info-section">
                <table>
                    <thead>
                        <tr>
                            <th>Variedad</th>
                            <th>Superficie</th>
                            <th>Kilos Ingresados</th>
                        </tr>
                    </thead>
                    <tbody>
                        {DJCEData?.djceUvas?.map((it, i) => {
                            return (
                                <tr key={i}>
                                    <td>{it.variedad}</td>
                                    <td>{it.superficie} m²</td>
                                    <td>{it.kilos} kg</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </section>
            <footer className="DJCE-footer">
                <label>
                    <span>Total Kilos de Producción: </span>
                    <p>{DJCEData?.declaracion?.total_Kilos} kg</p>
                </label>
            </footer>
            <button
                className="btn btn-primary DJCE-btn-print"
                onClick={handlePrint}
            >
                <img className="DJCE-img-print" src={print} alt="Impresíon" />
                <small>Impresión</small>
            </button>
            {user.tipo === 3 && (
                <section className="profile-fieldset_4">
                    <h4 className="profile-title">Historial de la DJCE</h4>
                    <button
                        className="btn btn-primary profile-history_btn"
                        onClick={() => setWatchDJCELogs(!WatchDJCELogs)}
                    >
                        {!WatchDJCELogs ? 'Ver Historial' : 'Ocultar Historial'}
                    </button>
                    {WatchDJCELogs && <DJCELogsContainer />}
                </section>
            )}
        </div>
    );
}

export default DJCE;
